import log from '../log'
import config from '../config'

const {
  metaOrganizationName
} = config

const defaultEventObj = {
  ga_event_category: null,
  ga_event_action: null,
  ga_event_label: null, // using for implicit values
  ga_event_value: null,
  ga_event_non_interaction: false,
  dataset_name: null,
  dataset_version: null,
  file_type: null,
  file_size: null,
  file_name: null,
  link_url: null,
  link_text: null,
  content_type: null, // need to hook up
  data_resource: null, // need to hook up, drupal resource
  grouping: null,
  search_term: null,
  search_results_num: null
}

class Analytics {
  constructor () {
    this.eventObj = defaultEventObj
    this.pendingPageviews = []
  }

  setResultsCount (count) {
    this.eventObj.search_results_num = count
  }

  setPageviewData (title, path) {
    this.eventObj.page_path = path
    this.eventObj.title = title
    this.eventObj.page_name = title
  }

  trackPageview (pageTitle, pagePath, utag) {
    const verifiedTitle = pageTitle.endsWith(metaOrganizationName) ? pageTitle : (pageTitle + metaOrganizationName)
    if (utag) {
      this.setPageviewData(verifiedTitle, pagePath)
      utag.view({ ...this.eventObj }, () => log.debug(`pageview payload - { title: '${this.eventObj.title}', page_path: '${this.eventObj.page_path}'}`))
    } else {
      this.pendingPageviews.push({ pageTitle: verifiedTitle, pagePath })
    }
  }

  flushPendingPageviews (utag) {
    if (!utag || this.pendingPageviews.length === 0) return
    const pending = [...this.pendingPageviews]
    this.pendingPageviews = []
    pending.forEach(({ pageTitle, pagePath }) => {
      this.setPageviewData(pageTitle, pagePath)
      utag.view({ ...this.eventObj }, () => log.debug(`pageview payload (queued) - { title: '${this.eventObj.title}', page_path: '${this.eventObj.page_path}'}`))
    })
  }

  trackEvent (eventData, utag) {
    if (utag) {
      const currentEventObj = { ...this.eventObj, ...eventData }
      utag.link({ ...currentEventObj }, () => log.debug(`event payload - { ${JSON.stringify(eventData)}, title: '${this.eventObj.title}', page_path: '${this.eventObj.page_path}'}`))
    }
  }
}

export default new Analytics()
